import { IconWrapper } from '../runtime';
export default IconWrapper('flow_chart_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#1289DE"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#0475C5"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#239FF7"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.46912 1.79297L2.82812 5.47983L4.81748 7.49331L5.88451 6.43907L4.93653 5.47959L6.46914 3.92768L8.18726 5.66742L4.36836 9.5344L6.34114 11.532H11.3636L13.3364 9.53439L11.0556 7.2249H10.4474L8.94744 8.7249H10.4288L11.2282 9.53439L10.7368 10.032H6.96796L6.47654 9.53439L10.2954 5.66741L6.46912 1.79297Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.81073 7.26786L8.85369 7.2249H8.81073V7.26786Z",
      "fill": "white"
    }
  })]);
});